import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';

interface MarketTotalRevenueCellsTdFilterSignature {
  Args: {
    cellData: {
      ariaLabel?: string;
      handleFilter: () => void;
    };
  };
}

const MarketTotalRevenueCellsTdFilter = <template>
  <div class="td-filter-container">
    <PrismButton
      @buttonType="secondary"
      @icon="filter"
      @onClick={{@cellData.handleFilter}}
      @size="small"
      aria-label={{if @cellData.ariaLabel @cellData.ariaLabel}}
      class="td-filter"
      data-test-id="td-filter"
    />
  </div>
</template> satisfies TOC<MarketTotalRevenueCellsTdFilterSignature>;

export default MarketTotalRevenueCellsTdFilter;
